import levels from './permissionLevels';
import funcPermissions from './funcPermissions';

export default {
  apiEndpoint: 'https://jmh-dev.voliasoftware.com/api',
  permissionLevels: levels,
  funcPermissions,
  default_tz: 'America/Chicago'
};



// WEBPACK FOOTER //
// ./src/config/index.js